import type { CreateSlideConfig, PostedCreateSlideConfig } from "./types";

/**
 * Strips the raw `File` objects out of a wizard config so it can cross the
 * dialog -> pane channel (a JSON string — see
 * service/createSlidesDialogChannel.ts). Only each document's name/size
 * survives, which is all the pane needs: document input reaches the backend
 * through blob storage, never as bytes over this channel.
 *
 * Shared by the two places that post a config out of the dialog — the final
 * "generate", and the templates path's outline request — so the two can never
 * disagree about what the pane receives.
 */
export function toPostedConfig(config: CreateSlideConfig): PostedCreateSlideConfig {
  return {
    ...config,
    documents: config.documents.map((doc) => ({ name: doc.name, chars: doc.chars })),
  };
}
